module.exports = __webpack_public_path__ + "img/ipad-sm-frame-landscape.5cefeb2.png";